<app-view-title Title="{{ 'Intellitrailer.MyPage.MyCampaings.Title' | translate : 'My offers' }}" [isPrimaryColor]="true"></app-view-title>
<div class="view-content-full centered-view" style="padding: 0px">

  <div class="toggle-tabs-container">
    <div class="toggle-tabs">
      <div class="toggle-tab-container" (click)="toggleTab(0)">
        <div class="toggle-tab" [ngClass]="currentTab == 0 ? 'toggle-tab-checked' : 'toggle-tab-unchecked'">
          {{ 'Intellitrailer.MyPage.MyCampaings.btnActiveCampaigns' | translate : 'Available' }}
        </div>
      </div>
      <div class="toggle-tab-container" (click)="toggleTab(1)">
        <div class="toggle-tab" [ngClass]="currentTab == 1 ? 'toggle-tab-checked' : 'toggle-tab-unchecked'">
          {{ 'Intellitrailer.MyPage.MyCampaings.btnHistoricCampaigns' | translate : 'Used / Expired' }}
        </div>
      </div>
    </div>
    <mat-tab-group [(selectedIndex)]="currentTab" class="header-tabs" style="margin:30px;" animationDuration="100ms">
      <mat-tab>
        <ng-container *ngFor="let campaign of activeCampaigns">
          <app-campaign-card [(campaign)]="campaign"></app-campaign-card>
        </ng-container>

        <ng-container *ngIf="activeCampaigns.length <= 0">
          <p> {{ 'Intellitrailer.MyPage.MyCampaings.msgNoCurrentOffers' | translate : 'You have no current offers.' }}</p>
        </ng-container>
      </mat-tab>

      <mat-tab>
        <ng-container *ngFor="let campaign of expiredCampaigns">
          <app-campaign-card [(campaign)]="campaign" historical="true"></app-campaign-card>
        </ng-container>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
